export const MAX_UPLOAD_IMAGE_SIZE_MB = 30
export const IMAGES_MIME_TYPES = ['image/jpeg', 'image/jpg', 'image/bmp', 'image/png', 'image/gif', 'image/svg+xml', 'image/webp']
export const MAX_UPLOAD_FILE_SIZE_MB = 100
export const VIDEOS_MIME_TYPES = ['video/mp4', 'video/webm']
export const VIDEOS_TYPES = ['mp4', 'webm']
export const OTHER_MIME_TYPES = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
export const ALLOWED_IMAGES_EXTS = ['jpeg', 'jpg', 'bmp', 'png', 'gif', 'svg', 'webp']
export const ALLOWED_VIDEOS_EXTS = ['mp4', 'webm']
export const ALLOWED_OTHER_EXTS = ['pdf', 'doc', 'docx', 'xls', 'xlsx']

export const PDF_MIME_TYPES = ['application/pdf']
export const ALLOWED_PDF_EXTS = ['pdf']

